<template>
  <div>
    <v-card>
      <v-card-title
        ><h1>{{ title }}</h1></v-card-title
      >
      <v-divider></v-divider>

      <v-card-text>
        <h2>Test Method</h2>
        <p>{{ vesselTrialTest.method || 'N/A' }}</p>

        <h2>Expected Results</h2>
        <p>{{ vesselTrialTest.expectedResults || 'N/A' }}</p>

        <h2>Actual Results</h2>
        <p>{{ vesselTrialTest.results || 'N/A' }}</p>

        <h2>Comments</h2>
        <p>{{ vesselTrialTest.comments || 'N/A' }}</p>

        <div v-if="vesselTrialTest.hasFindings">
          <h2>Recommendations</h2>
          <p>{{ vesselTrialTest.recommendations || 'N/A' }}</p>
        </div>
      </v-card-text>

      <v-divider></v-divider>

      <v-card-actions>
        <span class="font-weight-bold mr-1">Witnessed by:</span>
        {{ vesselTrialTest.assignedName || 'N/A' }}
        <v-spacer></v-spacer>
        <span class="font-weight-bold mr-1">Date:</span>
        {{ vesselTrialTest.completedString || 'In progress' }}
      </v-card-actions>
    </v-card>
    <div v-if="vesselTrialTest.hasFindings">
      <v-card class="mt-3">
        <v-card-text>
          <v-textarea
            v-model="vesselTrialTest.commentClosure"
            label="Comment Closure"
          ></v-textarea>
        </v-card-text>
      </v-card>
      <v-btn class="mt-3" color="primary" @click="putTrialTest" width="100%"
        >Save</v-btn
      >
    </div>
  </div>
</template>

<script>
import ApiService from '../services/ApiService'
import Objects from '../services/Objects'
export default {
  name: 'VesselTrialTestDetails',
  props: {
    vesselTrialTest: Object
  },
  computed: {
    title() {
      return `Test ${this.vesselTrialTest.order}: ${this.vesselTrialTest.name}`
    }
  },
  methods: {
    putTrialTest() {
      ApiService.put(
        Objects.VesselTrialTest,
        this.vesselTrialTest.vesselTrialTestId,
        this.vesselTrialTest
      )
    }
  }
}
</script>

<style scoped>
.v-card__actions {
  padding: 12px 16px;
}
</style>
